import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";

class ListaPrecio extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'lista-precio-tipo/one', saveUrl: 'lista-precio-tipo/save', backUrl: '/Catalogo/ListasPreciosTipos' },
      new Form([
        Form.Field('text', 'lpt_nombre', 'Nombre del Tipo de Lista', '', [Validators.required], 12),
      ], ['Guardar'], 'Tipo de Lista de Precio'), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds()
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(ListaPrecio)
